// extracted by mini-css-extract-plugin
export default {"menu-color":"#696d7a","menu-color-active":"#fff","menu-background":"rgba(0,0,0,0)"};